import script from "./auction-list.vue?vue&type=script&setup=true&lang=js"
export * from "./auction-list.vue?vue&type=script&setup=true&lang=js"

import "./auction-list.vue?vue&type=style&index=0&id=7ad0a748&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ad0a748"]])

export default __exports__